import { Component, OnInit } from '@angular/core';
import {
  TUI_PROMPT,
  TuiDataListWrapperModule,
  TuiInputModule,
  TuiPaginationModule,
  TuiPromptData,
  TuiSelectModule,
  TuiToggleModule,
} from '@taiga-ui/kit';
import {
  TuiAlertService,
  TuiButtonModule,
  TuiDataListModule,
  TuiDialogService,
  TuiDropdownModule,
  TuiTextfieldControllerModule,
  TuiSvgModule,
  TuiLoaderModule,
} from '@taiga-ui/core';
import { TuiTableModule } from '@taiga-ui/addon-table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MemberService } from '../../core/services/member.service';
import { PageSize } from '../../core/dto/page.size';
import { Router } from '@angular/router';
import { Pagination } from '../../core/dto/pagination';
import {
  TuiActiveZoneModule,
  TuiObscuredModule,
  TuiValueChangesModule,
} from '@taiga-ui/cdk';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../modules/auth/services/auth.service';

@Component({
  selector: 'app-members',
  standalone: true,
  imports: [
    TuiPaginationModule,
    TuiInputModule,
    TuiTableModule,
    TuiTextfieldControllerModule,
    TuiDataListWrapperModule,
    TuiDataListModule,
    TuiSelectModule,
    TuiButtonModule,
    TuiDropdownModule,
    ReactiveFormsModule,
    FormsModule,
    TuiValueChangesModule,
    CommonModule,
    TuiActiveZoneModule,
    TuiObscuredModule,
    TuiToggleModule,
    TuiSvgModule,
    TuiLoaderModule,
  ],
  providers: [MemberService],
  templateUrl: './members.component.html',
  styleUrl: './members.component.scss',
})
export class MembersComponent implements OnInit {
  paymentitems = ['Not Paid', 'Paid'];

  statusitems = ['Active', 'Inactive'];

  allPrograms: string[] = [
    'Personal Training',
    'Gym Only Use',
    'Combat Training',
    'Plan and Assessment',
  ];
  sessions: string[] = ['PT', 'Gym'];

  pageSize = new PageSize();
  searchText: any;
  memberPaymentStatus = 'Paid';
  memberStatus = 'Active';
  tempStatus = true;
  paymentStatus: any;
  statusMsg = false;
  memberData: any[] = [];
  openStates: boolean[] = [];
  isLoading = false;
  showSearch = false;
  sortDate = -1;
  sortMemberDate = -1;
  isDateSort = true;
  user: any;
  tempSearchText: any;

  constructor(
    private router: Router,
    private memberService: MemberService,
    private readonly dialogs: TuiDialogService,
    private readonly alerts: TuiAlertService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.user = this.authService.getLoggedInUser();
    this.getPaginatedMembers();
  }

  getPaginatedMembers(): void {
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      filters: {
        isDateSort: this.isDateSort,
        dateSort: this.sortDate,
        memberDateSort: this.sortMemberDate,
        searchValue: this.searchText,
        status: this.tempStatus,
        paymentStatus: this.paymentStatus,
      },
    });
    this.isLoading = true;
    this.memberService
      .getPagedMembers(payload)
      .then((res) => {
        this.memberData = res.data.map((member: any) => ({
          ...member,
          session: member.session?.[0] || 'Gym',
        }));
        this.isLoading = false;
        this.memberData.forEach(() => this.openStates.push(false));
        this.pageSize.length = res.totalPages;
      })
      .catch((error) => {
        this.isLoading = false;
      });
  }

  toggleSortMemberDate(): void {
    if (this.sortMemberDate === -1) {
      this.sortMemberDate = 1;
    } else {
      this.sortMemberDate = -1;
    }
    this.isDateSort = false;
    this.getPaginatedMembers();
  }

  toggleSortDate(): void {
    if (this.sortDate === -1) {
      this.sortDate = 1;
    } else {
      this.sortDate = -1;
    }
    this.isDateSort = true;
    this.getPaginatedMembers();
  }

  toggle(): void {
    this.showSearch = !this.showSearch;
  }

  statusChange(): void {
    this.tempStatus = !this.tempStatus;
  }

  resetStatus(): void {
    this.tempStatus = true;
    this.memberStatus = 'Active';
    this.statusMsg = true;
    this.searchText = null;
    this.tempSearchText = null;
    this.paymentStatus = null;
    this.getPaginatedMembers();
  }

  search(): void {
    this.statusMsg = true;
    this.tempSearchText = this.searchText;
    this.getPaginatedMembers();
  }

  cancelSearch(event: Event): void {
    if (!event) {
      this.searchText = null;
      this.getPaginatedMembers();
    }
  }

  showText(): string {
    let text = '';
    if (this.statusMsg && this.tempSearchText) {
      text += `Showing Results for "${this.tempSearchText}"`;
    }
    return text;
  }

  displayArrayWithCommas(array: string[] | null | undefined): string {
    if (!array || array.length === 0) {
      return '';
    } else if (array.length === 1) {
      return array[0];
    } else if (array.length === 2) {
      return array[0] + ',' + array[1];
    } else {
      return array[0] + ',' + array[1] + ` + ${array.length - 2} more`;
    }
  }

  goToPage(event: any): void {
    this.pageSize.pageIndex = event + 1;
    this.getPaginatedMembers();
  }

  navigateToAdd(): void {
    this.router.navigate(['admin/members/add-edit']);
  }

  navigateToUpdate(data: any): void {
    this.router.navigate([`admin/members/add-edit/${data._id}`]);
  }

  navigateToSingle(data: any): void {
    this.router.navigate([`admin/view-member/${data._id}`]);
  }

  viewPaymentAdd(data: any): void {
    this.router.navigate([`admin/payment/add-edit`, { user: data._id }]);
  }

  toggleDropdown(index: number): void {
    // Toggle the dropdown state for the specified row index
    this.openStates[index] = !this.openStates[index];
  }

  onClick(index: number): void {
    this.openStates.fill(false);
    console.log(this.openStates);
    this.toggleDropdown(index);
  }

  onActiveZone(event: any): void {
    // Handle active zone change event
    if (!event) {
      this.openStates.fill(false);
    }
  }

  onObscured(event: any): void {}

  formatDate(dateString: any) {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  }

  onStatusChange(user: any): void {
    let content = '';
    let yesLabel = '';
    let noLabel = '';

    if (user.isActive) {
      content = `Are you sure you want to deactivate Member : ${user.email}`;
      yesLabel = 'Deactivate';
      noLabel = 'Cancel';
    } else {
      content = `Are you sure you want to activate Member : ${user.email}`;
      yesLabel = 'Activate';
      noLabel = 'Cancel';
    }

    const data: TuiPromptData = {
      content: content,
      yes: yesLabel,
      no: noLabel,
    };

    this.dialogs
      .open<boolean>(TUI_PROMPT, {
        size: 's',
        data,
      })
      .subscribe((response) => {
        if (response) {
          user.isActive = !user.isActive;

          this.memberService
            .updateMember({
              _id: user._id,
              ...user,
            })
            .then(() => {
              this.openStates.fill(false);
              this.alerts
                .open(
                  '<p style="color: green">Member Status Changed Successfully</p>'
                )
                .subscribe();
              this.ngOnInit();
            })
            .catch(() => {
              this.alerts
                .open(
                  '<p style="color: red">Member Status Change UnSuccessful</p>'
                )
                .subscribe();
            });
        }
      });
  }

  onDelete(id: any, email: any): void {
    const data: TuiPromptData = {
      content: `Are you sure you want to delete ${email}`,
      yes: 'Yes',
      no: 'Cancel',
    };

    this.dialogs
      .open<boolean>(TUI_PROMPT, {
        size: 's',
        data,
      })
      .subscribe((response) => {
        if (response) {
          this.memberService
            .softDeleteMember(id)
            .then(() => {
              this.openStates.fill(false);
              this.alerts
                .open('<p style="color: green">Member Deleted Successfully</p>')
                .subscribe();
              this.ngOnInit();
            })
            .catch(() => {
              this.alerts
                .open('<p style="color: red">Deleting Member Unsuccessful</p>')
                .subscribe();
            });
        }
      });
  }

  savePrograms(member: any) {
    this.memberService
      .updateMember({
        _id: member._id,
        programs: member.programs,
      })
      .then(() => {
        this.alerts.open('Programs updated successfully!').subscribe();
      })
      .catch(() => {
        this.alerts.open('Failed to update programs').subscribe();
        this.getPaginatedMembers();
      });
  }

  onSessionChange(session: string, member: any): void {
    member.session = session;
    this.memberService
      .updateMember({
        _id: member._id,
        session: [member.session],
      })
      .then(() => {
        this.alerts.open(`Session updated to ${member.session}!`).subscribe();
      })
      .catch(() => {
        this.alerts.open('Failed to update session').subscribe();
        this.getPaginatedMembers();
      });
  }
}
